import styled from 'styled-components';

const SelectorDiv = styled.div`
  width: 100%;
  display: flex;
  max-width: 80%;
`;

export default SelectorDiv;
